import React, { useState, useEffect, useRef, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import PageHeader from "../../components/PageHeader/PageHeader";
import { Row as Brow, Col as Bcol } from "reactstrap";
import {
  Button,
  Form,
  Select,
  Table, Spin,
  DatePicker,
  Input
} from "antd";
import { ReadCookie } from "../../utils/readCookie";
import numeral from "numeral";
import { CSVLink } from "react-csv";
import { TabTitle } from "../../utils/GeneralFunction";
import moment from "moment";
import { getGender } from "../../redux/actions/gender.action";
import { getfocReport } from "../../redux/actions/focReport.action";
import { loadCustomers } from "../../redux/actions/customerForm";
import Loader from "react-spinners/BarLoader";
const { Option } = Select;

const FOCReport = () => {
  TabTitle("FOC Report")
  const [form] = Form.useForm();
  const [minimize, setMinimize] = useState(false);
  const dispatch = useDispatch();
  const menuId = ReadCookie("menuId");
  const token = ReadCookie("token");
  const [inventoryList, setInventoryList] = useState([]);
  const [loading, setLoading] = useState(false);
  const tableRef = useRef(null);
  const { focReport, gender, customerForms } = useSelector((state) => state);
  const [excelData, setExcelData] = useState([])
  const [customer, setCustomer] = useState("All");
  const focusInput = useRef(null);


  useEffect(() => {
    dispatch(getGender(token, menuId));
  }, [dispatch, menuId, token]);


  const columns = [
    {
      title: '#',
      dataIndex: 'index',
      key: 'index',
      render: (text, record, index) => {
        return index + 1;
      },
      width: 40,
    },
    {
      title: "SO#",
      dataIndex: "order_header_no",
      key: "order_header_no",
    },
    {
      title: "SO Date",
      dataIndex: "order_date",
      key: "order_date",
      render: (text, record, index) => {
        return moment(text).format("MM-DD-YYYY")
      },
    },
    {
      title: "Customer",
      dataIndex: "customer_name",
      key: "customer_name",
    },
    {
      title: "PO #",
      dataIndex: "reference_no",
      key: "reference_no",
    },
    {
      title: "Billing Addressee",
      dataIndex: "billing_addressee",
      key: "billing_addressee",
    },
    {
      title: "Billing First Name",
      dataIndex: "billing_first_name",
      key: "billing_first_name",
    },
    {
      title: "Billing Last Name",
      dataIndex: "billing_last_name",
      key: "billing_last_name",
    },
    {
      title: "Shipping Addressee",
      dataIndex: "shipping_addressee",
      key: "shipping_addressee",
    },
    {
      title: "Shipping First Name",
      dataIndex: "shipping_first_name",
      key: "shipping_first_name",
    },
    {
      title: "Shipping Last Name",
      dataIndex: "shipping_last_name",
      key: "shipping_last_name",
    },
    {
      title: "Memo",
      dataIndex: "memo",
      key: "memo",
    },
    {
      title: "SKU",
      dataIndex: "item_code",
      key: "item_code",
    },
    {
      title: "SO Qty",
      dataIndex: "so_qty",
      key: "so_qty",
      align: "right"
    },
    {
      title: "PT Qty",
      dataIndex: "pt_qty",
      key: "pt_qty",
      align: "right"
    },
    {
      title: "INV Qty",
      dataIndex: "inv_qty",
      key: "inv_qty",
      align: "right"
    },
    {
      title: "SO Adj Qty",
      dataIndex: "so_adj_qty",
      key: "so_adj_qty",
      align: "right"
    },
    {
      title: "Wholesale Cost",
      dataIndex: "cost_price",
      key: "cost_price",
      render: (text, record) => {
        return <>$ {numeral(text).format("0,00.00")}</>
      },
      align: "right"
    },
    {
      title: "Retail Cost",
      dataIndex: "rate",
      key: "rate",
      render: (text, record) => {
        return <>$ {numeral(text).format("0,00.00")}</>
      },
      align: "right"
    },
    {
      title: "Gender ",
      dataIndex: "gender_name",
      key: "gender_name",
    },
  ];


  const onFinish = async () => {
    setLoading(true);
    await form.validateFields().then((values) => {
      dispatch(getfocReport(token, values)).then((res) => {
        setLoading(false);
        setInventoryList(res?.payload?.data);
        downloadExcelFileData(res?.payload?.data);
      });
    }).catch((error) => {
      setLoading(false);
    })
  }

  function downloadExcelFileData(data) {
    setExcelData(
      data.map((v) => {
        return {
          "SO#": v.order_header_no,
          "SO Date": v.order_date,
          "Customer": v.customer_name,
          "PO #": v.reference_no,
          "Billing Addressee": v.billing_addressee,
          "Billing First Name": v.billing_first_name,
          "Billing Last Name": v.billing_last_name,
          "Shipping Addressee": v.shipping_addressee,
          "Shipping First Name": v.shipping_first_name,
          "Shipping Last Name": v.shipping_last_name,
          "Memo": v.memo,
          "SKU": v.item_code,
          "SO Qty": v.so_qty,
          "PT Qty": v.pt_qty,
          "INV Qty": v.inv_qty,
          "SO Adj Qty": v.so_adj_qty,
          "Wholesale Cost": v.cost_price,
          "Retail Cost": v.rate,
          "Gender": v.gender_name,
        };
      })
    )
  }


  function debounce(cb, delay = 1000) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        cb(...args);
      }, delay);
    };
  }

  const handleChanges = (val) => {
    if (val === "" || val === "All") return;
    setCustomer(val);
    dispatch(loadCustomers(token, null, null, null, null, null, val, null, null, null, null, null, null, null, null, null, null, null, null)).then(
      (res) => {
        if (res?.type === "GET_ALL_CUSTOMERS_SUCCESS") {
          setCustomer(res?.payload?.data);
        }
      }
    );
  };

  const optimizedFn = useCallback(debounce(handleChanges), []);


  // const totalQuantity = () => {
  //   let sumQty = inventoryList.reduce(function (previousValue, currentValue) {
  //     return previousValue += Number(currentValue.on_hand_quantity);
  //   }, 0);
  //   return sumQty;
  // }

  // const totalSum = () => {
  //   let sumAmount = inventoryList.reduce(function (previousValue, currentValue) {
  //     return previousValue += Number(currentValue.cost_price);
  //   }, 0);
  //   return sumAmount;
  // }


  return (
    <div className="styleContainer">
      <div className="styleBody h-100">
        <PageHeader
          title={"FOC Report"}
          minimize={setMinimize}
          check={minimize}
        />
        {!minimize && (
          <div className="bodyStyle">
            <div className="formProduct p-0">
              <Form onFinish={onFinish} form={form} name="control-hooks">
                <div className="container-fluid pbpx-5 ptpx-5">
                  <Brow>
                    <Bcol lg={6} xl={4} xxl={3}>
                      <div >
                        <div className="relative">
                          <Form.Item
                            name="from_date"
                            label="From Date:"
                            labelAlign="left"
                            labelCol={{ span: 8 }}
                            wrapperCol={{ span: 16 }}
                            initialValue={moment().startOf('year')}
                          >
                            <DatePicker
                              size='small'
                              className="styleInput w-100"
                              format={"MM-DD-YYYY"}
                              defaultValue={moment().format("MM-DD-YYYY")}
                            />
                          </Form.Item>
                        </div>
                      </div>
                    </Bcol>
                    <Bcol lg={6} xl={4} xxl={3}>
                      <div >
                        <div className="relative">
                          <Form.Item
                            name="to_date"
                            label="To Date:"
                            labelAlign="left"
                            labelCol={{ span: 8 }}
                            wrapperCol={{ span: 16 }}
                            initialValue={moment().endOf('year')}
                          >
                            <DatePicker
                              size='small'
                              className="styleInput w-100"
                              format={"MM-DD-YYYY"}
                              defaultValue={moment().format("MM-DD-YYYY")}
                            />
                          </Form.Item>
                        </div>
                      </div>
                    </Bcol>
                    <Bcol lg={6} xl={4} xxl={3}>
                      <div className="slc">
                        <Form.Item
                          name="gender"
                          label="Gender"
                          labelAlign="left"
                          labelCol={{ span: 8 }}
                          wrapperCol={{ span: 16 }}
                          initialValue={"All"}
                        >
                          <Select
                            size='small'
                            showSearch
                            optionFilterProp="children"
                            className="styleInput w-100"
                            defaultValue={form.getFieldValue().gender}
                          >
                            <option value="All">All</option>
                            {
                              gender?.payload?.data.map((val) => {
                                return (
                                  <Option key={val.gender_id} value={val.gender_id}>{val.gender_name}</Option>
                                )
                              })
                            }

                          </Select>
                        </Form.Item>
                      </div>
                    </Bcol>
                    <Bcol lg={6} xl={4} xxl={3}>
                      <div >
                        <div className="relative">
                          <Form.Item
                            label="Customer"
                            name="customer_id"
                            labelAlign="left"
                            labelCol={{ span: 8 }}
                            wrapperCol={{ span: 16 }}
                            initialValue={customer}
                          >
                            <Select
                              notFoundContent={
                                customerForms.loading ? (
                                  <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                    <Loader type="Oval" color="#3c4b58" height={20} width={20} />
                                  </div>
                                ) : (
                                  <div style={{ display: "flex", justifyContent: "center", alignItems: "center", textAlign: "center" }}>
                                    No Data
                                  </div>
                                )
                              }
                              showSearch
                              optionFilterProp="children"
                              className={"select_Inputs w-100"}
                              loading={customerForms?.loading}
                              size="small"
                              onSearch={(value) => {
                                optimizedFn(value);
                              }}
                              ref={focusInput}
                              value={customer}
                            >
                            <Option value="All">All</Option>
                              {customerForms?.payload?.data.map((item) => {
                                return (
                                  <Option
                                    key={item.customer_id}
                                    value={item.customer_id}
                                  >
                                    {item.customer_name}
                                  </Option>
                                );
                              })}
                            </Select>
                          </Form.Item>
                        </div>
                      </div>
                    </Bcol>
                    <Bcol lg={6} xl={4} xxl={3}>
                      <div className="">
                        <div >
                          <Form.Item
                            name="sku"
                            label="Sku #"
                            labelAlign="left"
                            labelCol={{ span: 8 }}
                            wrapperCol={{ span: 16 }}
                          >
                            <Input
                              size='small'
                              className="styleInput"
                            />
                          </Form.Item>
                        </div>
                      </div>
                    </Bcol>
                    <Bcol lg={6} xl={4} xxl={3}>
                      <div className="">
                        <div >
                          <Form.Item
                            name="memo"
                            label="Memo"
                            labelAlign="left"
                            labelCol={{ span: 8 }}
                            wrapperCol={{ span: 16 }}
                          >
                            <Input
                              size='small'
                              className="styleInput"
                            />
                          </Form.Item>
                        </div>
                      </div>
                    </Bcol>
                  </Brow>
                </div>
              </Form>
              <Button
                htmlType="submit"
                type="primary"
                className="submit-btn-btm "
                onClick={onFinish}
              >
                Submit
              </Button>
            </div>
          </div>
        )}
      </div>
      <div style={{ marginTop: 10 }}>
        {
          loading ? (
            <div className=" report-wrapper-main d-flex align-items-center justify-content-center spin-style mt-3">
              <Spin size='large' />
            </div>
          ) : (
            inventoryList.length > 0 ? (
              <Table
                title={() =>
                  <CSVLink
                    filename={"FOC-Report.csv"}
                    data={excelData}
                    onClick={() => {

                    }}
                  >
                    Download Excel
                  </CSVLink>
                }
                ref={tableRef}
                size="small"
                bordered={false}
                type="company"
                perPage={15}
                scroll={{ x: 'max-content' }}
                dataSource={inventoryList}
                columns={columns}
                loading={focReport?.loading}
                pagination={{
                  defaultCurrent: 1,
                  defaultPageSize: 100,
                  pageSizeOptions: [100, 500, 1000, 2000, 2500, 3000]
                }}
              // summary={(pageData) => {
              //   let Qty = pageData.reduce(function (
              //     previousValue,
              //     currentValue
              //   ) {
              //     return (previousValue += parseFloat(
              //       currentValue.on_hand_quantity
              //     ));
              //   },
              //     0);
              //   let Amount = pageData.reduce(function (
              //     previousValue,
              //     currentValue
              //   ) {
              //     return (previousValue += parseFloat(
              //       currentValue.cost_price
              //     ));
              //   },
              //     0);
              //   return (
              //     <>
              //       <Table.Summary.Row>
              //         <Table.Summary.Cell colSpan={3}>Total Quantity : {numeral(totalQuantity()).format("0,00,0")}
              //         </Table.Summary.Cell>
              //         <Table.Summary.Cell>
              //           <p style={{ textAlign: "right" }} className="totalquantity">
              //             {Qty.toLocaleString("en-US")}
              //           </p>
              //         </Table.Summary.Cell>
              //         <Table.Summary.Cell>
              //           <p style={{ textAlign: "right" }} className="totalquantity">
              //             $ {Amount.toLocaleString("en-US")}
              //           </p>
              //         </Table.Summary.Cell>
              //       </Table.Summary.Row>
              //       <Table.Summary.Row>
              //         <Table.Summary.Cell colSpan={3} style={{ paddingTop: "10px", fontWeight: "bolder" }}>Total Amount : ${numeral(totalSum()).format("0,0.00")}
              //         </Table.Summary.Cell>
              //       </Table.Summary.Row>
              //     </>
              //   );
              // }}
              />
            ) : <div
              style={{
                backgroundColor: "#CCCCCC",
                borderWidth: "1pt",
                borderStyle: "Dashed",
                fontWeight: "bold",
                height: "25px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              No record(s)
            </div>
          )
        }
      </div>
    </div>
  )
}

export default FOCReport;
